import apiClient from '../Utils/apiClient';

const LoginController = {
  loginUser: async (loginData, onSuccess, setMessage, setErrorMessage) => {
    try {
      const response = await apiClient.post('auth/company/login', loginData);

      const token = response.data?.data?.token;
      if (token) {
        onSuccess(token);
        setMessage('Login successful');
      } else {
        setErrorMessage('Login failed: no token received.');
      }
    } catch (error) {
      const data = error.response?.data?.data;
      if (Array.isArray(data)) {
        const errorObj = {};
        data.forEach((el) => {
          errorObj[el.field] = errorObj[el.field]
            ? `${errorObj[el.field]}, ${el.message}`
            : el.message;
        });
        setErrorMessage(errorObj);
      } else if (data) {
        setErrorMessage(data);
      } else {
        setErrorMessage('Unable to login. Please try again.');
      }
    }
  },
};

export default LoginController;
